module.exports = __webpack_public_path__ + "img/1099630309.71187eeb.jpg";